import React from 'react';
import CountUp from 'react-countup';
import { Col, Row, Statistic } from 'antd';
const formatter = (value) => <CountUp end={value} separator="," />;
const TransactionOverviewPage = () => (
  <Row gutter={16}>
    <Col span={12}>
      <Statistic title="Transactions Count" value={1395} formatter={formatter} />
    </Col>
    <Col span={12}>
      <Statistic title="Account Balance (CAD)" value={112893} precision={2} formatter={formatter} />
    </Col>
  </Row>
);
export default TransactionOverviewPage;